<template>
  <div v-if="visible" class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-2xl w-full max-w-md p-8 animate-fade-in relative">
      <button @click="close" class="absolute top-4 right-4 text-gray-medium hover:text-dark transition-custom">
        <i class="fas fa-times text-xl"></i>
      </button>
      <div class="text-center mb-6">
        <h3 class="text-2xl font-bold text-dark">用户注册</h3>
        <p class="mt-2 text-gray-medium">请填写信息完成注册</p>
      </div>
      <form @submit.prevent="handleRegister" class="space-y-5">
        <div>
          <label for="registerPhone" class="block text-sm font-medium text-gray-dark mb-1">手机号码</label>
          <input 
            type="tel" 
            id="registerPhone" 
            v-model="form.phone"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请输入手机号码"
          >
        </div>
        <div>
          <label for="registerPassword" class="block text-sm font-medium text-gray-dark mb-1">密码</label>
          <input 
            type="password" 
            id="registerPassword" 
            v-model="form.password"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请输入密码（6-20位）"
          >
        </div>
        <div>
          <label for="confirmPassword" class="block text-sm font-medium text-gray-dark mb-1">确认密码</label>
          <input 
            type="password" 
            id="confirmPassword" 
            v-model="form.confirmPassword"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom" 
            placeholder="请再次输入密码"
          >
        </div>
        <label class="flex items-start">
          <input type="checkbox" v-model="form.agree" class="w-4 h-4 text-primary focus:ring-primary border-gray-light rounded mt-1">
          <span class="ml-2 text-sm text-gray-dark">我已阅读并同意<a href="#" class="text-primary hover:underline">《用户服务协议》</a>和<a href="#" class="text-primary hover:underline">《隐私政策》</a></span>
        </label>
        <button 
          type="submit" 
          :disabled="loading"
          class="w-full py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-custom shadow-sm disabled:opacity-70 disabled:cursor-not-allowed"
        >
          <span v-if="loading">
            <i class="fas fa-spinner fa-spin mr-2"></i>注册中...
          </span>
          <span v-else>注册</span>
        </button>
      </form>
      <div class="mt-6 text-center">
        <p class="text-sm text-gray-medium">已有账号？<a href="#" @click="switchToLogin" class="text-primary hover:underline">立即登录</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { register } from '@/api/index'

export default {
  name: 'RegisterModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {
        phone: '',
        password: '',
        confirmPassword: '',
        agree: false
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
      document.body.style.overflow = ''
      // 清空表单
      this.form = {
        phone: '',
        password: '',
        confirmPassword: '',
        agree: false
      }
    },
    switchToLogin() {
      this.$emit('switch-to-login')
    },
    async handleRegister() {
      // 表单验证
      if (!this.form.phone) {
        this.$message.error('请输入手机号码')
        return
      }
      
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.form.phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      
      if (!this.form.password) {
        this.$message.error('请输入密码')
        return
      }
      
      if (this.form.password.length < 6 || this.form.password.length > 20) {
        this.$message.error('密码长度应为6-20位')
        return
      }
      
      if (!this.form.confirmPassword) {
        this.$message.error('请确认密码')
        return
      }
      
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.error('两次输入的密码不一致')
        return
      }
      
      if (!this.form.agree) {
        this.$message.error('请阅读并同意用户服务协议和隐私政策')
        return
      }
      
      try {
        this.loading = true
        
        // 调用注册接口
        const data = {
          mobile: this.form.phone,
          password: this.form.password
        }
        
        const response = await register(data)
        
        this.$message.success('注册成功！')
        
        // 注册成功后的处理
        this.$emit('register-success', response)
        
        // 关闭弹窗
        this.close()
        
        // 可选：自动登录或跳转到登录页
        setTimeout(() => {
          this.$emit('switch-to-login')
        }, 500)
        
      } catch (error) {
        console.error('注册失败:', error)
        this.$message.error(error.msg || '注册失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.transition-custom {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style> 